import useConfigCode from "@/features/sub-families/hooks/use-config-code.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { getAccessoryByConfigCode } from "@/services/product/utils/accessories.ts";
import { SmartNumberDescriptor } from "@/types";

export default function useCurrentAccessory() {
    const product = useCurrentProduct();
    const { getConfigCodeByDescriptor } = useConfigCode();

    return getAccessoryByConfigCode(product, getConfigCodeByDescriptor(SmartNumberDescriptor.Accessory));
}
